// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2PwvT","rootCenter":"LoadMoreObserver_rootCenter__3TXOb","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3vD4x"};